import { createApp } from 'vue'
import { router } from './router';
import App from './App.vue'
import {BootstrapVue3, BToastPlugin} from 'bootstrap-vue-3'
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/reset.css';
import VueSelect from 'vue3-select2-component'
import VCalendar from 'v-calendar';
import VueFeather from 'vue-feather';
import DatePicker from 'vue3-datepicker';
import 'vue3-datepicker/dist/vue3-datepicker.css';
import VueApexCharts from "vue3-apexcharts";
import Vue3Autocounter from 'vue3-autocounter';
import VueTelInput from 'vue3-tel-input';
import Treeselect from 'vue3-treeselect'
import { TreeView } from "vue-tree-view";
import VueMultiselect from 'vue-multiselect'

import { FileUpload } from 'primevue/fileupload';
import { RootTree } from "vue3-jstree-component"



// plugins
import 'bootstrap/dist/css/bootstrap.min.css';

import 'bootstrap-vue/dist/bootstrap-vue.css';
import '@fortawesome/fontawesome-free/css/fontawesome.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'vue3-tel-input/dist/vue3-tel-input.css';



/***********************************************************************/
                      /*  Admin */

/***********************************************************************/


import AdminHeader from '@/views/admin/layouts/adminheader.vue'
import AdminSidebar from '@/views/admin/layouts/adminsidebar.vue'
import AdminFooter from '@/views/admin/layouts/adminfooter.vue'




// IMPORT THƯ VIỆN
import store from '@/state/store'
import axios from "axios";
window.axios  = axios;


// Ckeditor
import CKEditor from '@ckeditor/ckeditor5-vue';
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'







const app = createApp(App);


 /*************************** Admin ****************************/

app.component('adminheader',AdminHeader)
app.component('adminsidebar',AdminSidebar)
app.component('adminfooter',AdminFooter)

app.component('Treeselect', Treeselect)
app.component('VueMultiselect ', VueMultiselect )
app.component('TreeView ', TreeView )
app.component('RootTree ', RootTree )
app.component('FileUpload ', FileUpload )
//app.component('VJstree', VJstree)
app.component('vue3-autocounter', Vue3Autocounter)
app.component('vue-select', VueSelect)
app.component(VueFeather.name, VueFeather)
app.component('datepicker', DatePicker)

app.use(VueApexCharts)
.use(VueTelInput)
    .use(BootstrapVue3)
    .use(BToastPlugin)
.use(Antd)
app.use(VCalendar, {})
app.use(store)

//ckedittor

app.use(CKEditor)
app.use(VueDatePicker)


app.use(router).mount('#app');
